import React from "react";
import "./banner.css";
import bannerImage from "../../../images/Agent Trust Images/assets/BannerSection/banner-image.svg";
import awsIcon from "../../../images/Agent Trust Images/assets/PartnerSection/amazon-icon.png";
import cisco from "../../../images/Agent Trust Images/assets/PartnerSection/cisco-icon.png";
import atTIcon from "../../../images/Agent Trust Images/assets/PartnerSection/at-and-t-icon.png";
import dellIcon from "../../../images/Agent Trust Images/assets/PartnerSection/dell-icon.png";
import comcastIcon from "../../../images/Agent Trust Images/assets/PartnerSection/comcast-icon.png";
import verizonIcon from "../../../images/Agent Trust Images/assets/PartnerSection/verizon-icon.png";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import config from "../../../config";

export default function Banner() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  return (
    <section
      className={`agent-trust-banner-section ${isVisible ? "animate" : ""}`}
      ref={ref}
    >
      <div className="container">
        {/* Banner Content */}
        <div className="banner-content-wrapper">
          <div className="left-side">
            <h1>
              Agent Trust - Measuring AI Integrity for Confident Decision-Making
            </h1>
            <p>
              Agent Trust provides an AI Trust Score, a comprehensive metric
              that evaluates the reliability, fairness, and security of AI
              systems, ensuring ethical and responsible AI adoption.
            </p>
            <div className="banner-button-wrapper">
              <a href={config.bookdemo.agentTrustBookDemoLink}>
                <button className="banner-button">
                  <p>Book Demo</p>
                </button>
              </a>
            </div>
          </div>
          <div className="right-side">
            <img
              src={bannerImage}
              alt="Investigation, Alerts, and Recommendation"
              loading="eager"
            />
          </div>
        </div>
        <div className="trusted-by-partners-wrapper">
          <h2>Build Trust and Transparency with Industry-Leading Partners</h2>
          <div className="row partner-logo-images">
            <img src={awsIcon} alt="Amazon Logo" />
            <img src={cisco} alt="Cisco Logo" />
            <img src={atTIcon} alt="At and T Logo" />
            <img src={dellIcon} alt="Dell Logo" />
            <img src={comcastIcon} alt="Comcast Logo" />
            <img src={verizonIcon} alt="Verizon Logo" />
          </div>
        </div>
      </div>
    </section>
  );
}
